module.exports = __webpack_public_path__ + "static/media/Spinner-1s-200px.2ba38b84.gif";